import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home",
  id: "home"
}
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-kicker hero-enter" }
const _hoisted_5 = { class: "hero-actions hero-enter hero-enter-delay-two" }
const _hoisted_6 = {
  href: "#contact",
  class: "button button-primary"
}
const _hoisted_7 = {
  href: "#references",
  class: "button button-ghost"
}
const _hoisted_8 = { class: "hero-note" }

import { ArrowDown, ArrowUpRight, Check, Leaf } from "lucide-vue-next";
import { onBeforeUnmount, onMounted } from "vue";
import "@/assets/styles/home.css";
import AboutView from "@/views/AboutView.vue";
import ReferencesView from "@/views/ReferencesView.vue";
import ReviewView from "@/views/ReviewView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ContactView from "@/views/ContactView.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
import SidebarComponent from "@/components/SidebarComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

let observer: IntersectionObserver | undefined;

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer?.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(".reveal").forEach((el) => observer?.observe(el));
});

onBeforeUnmount(() => observer?.disconnect());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarComponent),
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "hero-ambient hero-ambient-one" }, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-ambient hero-ambient-two" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Leaf), { size: 16 }),
            _cache[0] || (_cache[0] = _createTextVNode(" GaLaBau für Gewerbe, Kommunen & Privatkunden ", -1))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "hero-enter hero-enter-delay" }, [
            _createTextVNode(" Wir gestalten "),
            _createElementVNode("em", null, "Freiraum."),
            _createElementVNode("br"),
            _createTextVNode("Und Werte, die bleiben. ")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hero-lead hero-enter hero-enter-delay-two" }, " Von der ersten Idee bis zur dauerhaften Pflege: Wir entwickeln Außenanlagen, die ästhetisch überzeugen, wirtschaftlich funktionieren und jeden Tag gerne genutzt werden. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _cache[1] || (_cache[1] = _createTextVNode("Projekt besprechen ", -1)),
              _createVNode(_unref(ArrowUpRight), { size: 19 })
            ]),
            _createElementVNode("a", _hoisted_7, [
              _cache[2] || (_cache[2] = _createTextVNode("Arbeiten ansehen ", -1)),
              _createVNode(_unref(ArrowDown), { size: 19 })
            ])
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-proof hero-enter hero-enter-delay-two" }, [
          _createElementVNode("div", { class: "proof-item" }, [
            _createElementVNode("strong", null, "15+"),
            _createElementVNode("span", null, "Jahre Erfahrung")
          ]),
          _createElementVNode("div", { class: "proof-item" }, [
            _createElementVNode("strong", null, "240"),
            _createElementVNode("span", null, "realisierte Projekte")
          ]),
          _createElementVNode("div", { class: "proof-item" }, [
            _createElementVNode("strong", null, "1"),
            _createElementVNode("span", null, "Team, das mitdenkt")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(Check), { size: 16 }),
          _cache[5] || (_cache[5] = _createTextVNode(" Persönlich geplant · fachgerecht gebaut · verlässlich gepflegt ", -1))
        ])
      ]),
      _createVNode(AboutView),
      _createVNode(ServiceView),
      _createVNode(ReferencesView),
      _createVNode(ReviewView),
      _createVNode(ContactView)
    ]),
    _createVNode(FooterImpressum)
  ]))
}
}

})